import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-upgrade__title" }
const _hoisted_2 = { class: "onboarding-upgrade__subtitle" }
const _hoisted_3 = {
  key: 0,
  class: "onboarding-upgrade__footer"
}

import { computed, ref } from 'vue'

import { getImage } from '@/models/onboarding'
import type { QuestionnaireView } from '@/models/onboarding'
import type { UpgradePage } from '@/models/onboarding.types'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Upgrade',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const riveRef = ref<InstanceType<typeof Rive> | null>(null)

const currentSection = ref(0)
const showFooter = ref(true)

const page = computed(() => {
  return props.view.currentPage as UpgradePage
})

const colors = ['#1F5BCF', '#5AA96B', '#FF7124']

function nextSection(): void {
  currentSection.value += 1
}

function nextPage(): void {
  const lastSection = page.value.sectionTitles.length - 1
  if (currentSection.value === lastSection) {
    showFooter.value = false
    props.view.showContinueButton()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, { class: "onboarding-upgrade" }, {
    default: _withCtx(() => [
      _createVNode(Rive, {
        ref_key: "riveRef",
        ref: riveRef,
        class: "onboarding-upgrade__rive",
        src: _unref(getImage)(page.value.animation.src),
        width: page.value.animation.width,
        height: page.value.animation.height,
        animations: `${currentSection.value}`,
        onLoop: nextSection,
        onStop: nextPage
      }, null, 8, ["src", "width", "height", "animations"]),
      _createVNode(_Transition, {
        name: "upgrade-title",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            key: currentSection.value,
            class: "onboarding-upgrade__text"
          }, [
            _createElementVNode("h1", _hoisted_1, [
              _createTextVNode(_toDisplayString(page.value.title) + " ", 1),
              _createElementVNode("span", {
                class: "onboarding-upgrade__current-title",
                style: _normalizeStyle({
              '--upgrade-color': colors[currentSection.value % colors.length],
            })
              }, _toDisplayString(page.value.sectionTitles[currentSection.value]), 5)
            ]),
            _createElementVNode("p", _hoisted_2, _toDisplayString(page.value.sectionSubtitles[currentSection.value]), 1)
          ]))
        ]),
        _: 1
      }),
      (showFooter.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " One app. Big results in every part of your life. "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})